export const JSON_ONE41 = {
   
  
    "id": null,
    "account_holder_name": null,
    "account_number": null,
    "account_type": null,
    "average_ticket_size": null,
    "ag_id": null,
    "bank_city": null,
    "bank_id": null,
    "bussiness_description": null,
    "category_id": null,
    "city": null,
    "company_phone": null,
    "country_code": null,
    "createdBy": null,
    "creationDate": null,
    "director_email": null,
    "director_name": null,
    "director_phone": null,
    "document_urls": null,
    "email_id": null,
    "first_name": null,
    "ifsc_code": null,
    "is_paid": null,
    "ag_ref": null,
    "last_name": null,
    "merchant_name": null,
    "meId": null,
    "mobile_no": null,
    "modificationDate": null,
    "modifiedBy": null,
    "office_address": null,
    "pan_number": null,
    "password": null,
    "pincode": null,
    "pricing_plan": null,
    "settlement_currency": null,
    "state": null,
    "status": null,
    "sub_category": null,
    "turnover": null,
    "website_url": null,
    "message": "Document uploaded Successfully",
    "reId": null,
    "statusCode": "00",
    "legal_name": null,
    "legal_office_address": null,
    "company_name": null,
    "indianCustomer": null,
    "iAgree": null,
    "businessType": null
        }

